const SENTRY_ENVIRONMENTS = new Set(['production', 'staging']);
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export function isLocalHostname(hostname: string) {
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, '');

  return LOCAL_HOSTNAMES.has(normalizedHostname) || normalizedHostname.endsWith('.localhost');
}

export function shouldEnableSentry(environment: string | undefined, hostname: string) {
  const normalizedEnvironment = environment?.trim().toLowerCase();

  return Boolean(normalizedEnvironment && SENTRY_ENVIRONMENTS.has(normalizedEnvironment) && !isLocalHostname(hostname));
}

export function shouldUploadSentrySourceMaps(environment: string | undefined, authToken: string | undefined) {
  const normalizedEnvironment = environment?.trim().toLowerCase();

  return Boolean(normalizedEnvironment && SENTRY_ENVIRONMENTS.has(normalizedEnvironment) && authToken?.trim());
}
